/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ServiceUserLieSearch
 */
export interface ServiceUserLieSearch {
    /**
     * 
     * @type {number}
     * @memberof ServiceUserLieSearch
     */
    idService?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServiceUserLieSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ServiceUserLieSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceUserLieSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ServiceUserLieSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ServiceUserLieSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceUserLieSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ServiceUserLieSearch interface.
 */
export function instanceOfServiceUserLieSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ServiceUserLieSearchFromJSON(json: any): ServiceUserLieSearch {
    return ServiceUserLieSearchFromJSONTyped(json, false);
}

export function ServiceUserLieSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceUserLieSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idService': !exists(json, 'idService') ? undefined : json['idService'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ServiceUserLieSearchToJSON(value?: ServiceUserLieSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idService': value.idService,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

